var styles = {"name":"styles_name__2bpac bold mb1","category":"styles_category___3oNN","avatar-container":"styles_avatar-container__3f8lu mb2","avatarContainer":"styles_avatar-container__3f8lu mb2"};

export default styles;
//# sourceMappingURL=styles.css.js.map
